<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">



                <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getAllProductMasterGroupByWildSearch(0,10)" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getAllProductMasterGroupByWildSearch(0,10)"></i>
                  </div>
                    <button data-toggle="modal" title="Add" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>

                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">{{ 'product-master-group.id' | translate }}</th>
                            <th style="width: 35%;">{{ 'product-master-group.name' | translate }}</th>
                            <th style="width: 35%;">{{ 'product-master-group.description' | translate }}</th> 
                            <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let list of productGroupList | paginate : {
                        itemsPerPage: recordsPerPage,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">
                        <p style="width: 20%;">{{list.productMasterGroupId}}</p>
                        <p style="width: 35%;">{{list.name}}</p>
                        <p style="width: 35%;">{{list.description}}</p>
                        <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                            <i (click)="selectDelete(list.id,list)" title="Delete" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && productGroupList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="recordsPerPage" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>
        
          
            </div>
        </div>
    </div>
</div>
    


<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'product-master-group.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
                <div [formGroup]="form">
                    <div class="form-group">
                        <label>{{ 'product-master-group.name' | translate }} <span class="required">*</span></label>
                        <input formControlName="name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'product-master-group.description' | translate }}</label>
                        <textarea formControlName="description" class="form-control" name="" id="" cols="30" rows="3"></textarea>
                    </div>
                </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addProductMasterGroup()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID: {{recordId}})”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton" (click)="closeModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteProductMasterGroup()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>